(() => {
  'use strict';
  if (!document.body.classList.contains('rutina-landing') || window.rutinaLandingInitialized) return;
  window.rutinaLandingInitialized = true;

  const sent = new Set();
  const emit = (event, formId) => {
    // No email, consent value or other profile data is forwarded to analytics.
    if (window.Shopify?.designMode) return;
    const key = `${event}:${formId}`;
    if (sent.has(key)) return;
    sent.add(key);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, form_id: formId, landing: document.body.dataset.landing || 'sobreviviralarutina26', variant: 'minimal_header_v1' });
  };

  const enhanceForms = () => {
    document.querySelectorAll('[data-rutina-section]').forEach(section => {
      section.querySelectorAll('[data-rutina-form] form').forEach(form => {
        const email = form.querySelector('input[type="email"]');
        const consent = form.querySelector('input[type="checkbox"]');
        const button = form.querySelector('button.klaviyo-form-button');
        if (!email || !consent || !button) return;
        const consentRow = consent.closest('[data-testid="form-row"]');
        const buttonRow = button.closest('[data-testid="form-row"]');
        // Move existing sibling rows: keep Klaviyo's inputs, listeners and validation.
        // DOM order also puts the mandatory checkbox before the CTA for keyboard users.
        if (consentRow && buttonRow && consentRow.parentElement === buttonRow.parentElement &&
            consentRow.nextElementSibling !== buttonRow) {
          buttonRow.parentElement.insertBefore(consentRow, buttonRow);
        }
      });
    });
  };

  const closedPopups = new WeakSet();
  const popupIds = ['TYAitG', 'U2iGvr', 'RBaPGe'];
  const closeCompetingForms = () => {
    popupIds.forEach(id => {
      document.querySelectorAll(`[data-testid="klaviyo-form-${id}"]`).forEach(form => {
        const popup = form.closest('[data-testid="modal-form-container"]') || form.closest('.klaviyo-popup') || form.closest('[role="dialog"]');
        const close = popup?.querySelector('button[aria-label*="Close"], button[aria-label*="Cerrar"], button[data-testid="close-button"]');
        if (close && !closedPopups.has(form)) {
          closedPopups.add(form);
          close.click();
        }
      });
    });
  };

  const refresh = () => { enhanceForms(); closeCompetingForms(); };
  const observer = new MutationObserver(refresh);
  observer.observe(document.body, { childList: true, subtree: true });
  refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('focusin', event => {
    const section = event.target.closest('[data-rutina-section]');
    if (section && event.target.matches('input[type="email"]')) emit('leadmagnet_form_start', section.dataset.formId);
  });
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail || {};
    const section = [...document.querySelectorAll('[data-rutina-section]')].find(el => el.dataset.formId === detail.formId);
    if (!section) return;
    if (detail.type === 'embedOpen') emit('leadmagnet_form_ready', detail.formId);
    // A Klaviyo submit is not proof of confirmed opt-in or successful email delivery.
    if (detail.type === 'submit') emit('leadmagnet_form_submit', detail.formId);
  });
})();
